// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

export const gallery = () => {
  const galleryEl = '.is-style-carousel';

  //rework default gallery block markup
  $(galleryEl)
    .addClass('swiper')
    .append('<div class="swiper-pagination">')
    .append('<div class="swiper-button-prev">')
    .append('<div class="swiper-button-next">')
    .find('ul')
    .removeClass('blocks-gallery-grid')
    .addClass('swiper-wrapper')
    .find('li')
    .removeClass('blocks-gallery-item')
    .addClass('swiper-slide');

  new Swiper(galleryEl, {
    //loop: true,
    //speed: 800,
    spaceBetween: 4,
    // autoplay: {
    //   delay: 4000,
    //   disableOnInteraction: true,
    // },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
  });
  // //group blocks
  // const swiperEl = '.swiper-group > div';
  // $(swiperEl)
  //   .append('<div class="swiper-pagination">')
  //   .append('<div class="swiper-button-prev">')
  //   .append('<div class="swiper-button-next">');
  // new Swiper(swiperEl, {
  //   // scrollbar: '.swiper-scrollbar',
  //   // scrollbarHide: true,
  //   loop: true,
  //   slidesPerView: 1, //1.41,
  //   spaceBetween: 16,
  //   initialSlide: 0,
  //   loopedSlides: 5,
  //   createElements: true,
  //   centeredSlides: true,
  //   breakpoints: {
  //     // when window width is <= 499px
  //     1320: {
  //       slidesPerView: 2,
  //       centeredSlides: false,
  //       spaceBetween: 20,
  //     },
  //   },
  //   //slidesPerGroup: 2,
  //   //centeredSlides: true,
  //   pagination: {
  //     el: '.swiper-pagination',
  //     type: 'custom',
  //     renderCustom: function (swiper, current, total) {
  //       return (
  //         '<span class="swiper-pagination-current">' +
  //         ('0' + current).slice(-2) +
  //         '</span> of <span class="swiper-pagination-total">' +
  //         ('0' + total).slice(-2) +
  //         '</span>'
  //       );
  //     },
  //   },
  //   navigation: {
  //     nextEl: '.swiper-button-next',
  //     prevEl: '.swiper-button-prev',
  //   },
  // });

  // //HOMEPAGE HERO PURPLE COLS
  // const $heroCols = $('.pattern-hero-a .wp-block-columns');

  // const $heroColsSlider = $heroCols.clone();

  // $heroColsSlider
  //   .addClass('mobile')
  //   .wrapInner('<div class="swiper-wrapper">')
  //   .append('<div class="swiper-pagination">')
  //   .find('.wp-block-column')
  //   .addClass('swiper-slide');

  // $heroCols.after($heroColsSlider);

  // new Swiper('.pattern-hero-a .wp-block-columns.mobile', {
  //   // scrollbar: '.swiper-scrollbar',
  //   // scrollbarHide: true,

  //   loop: false,
  //   slidesPerView: 'auto',
  //   spaceBetween: 20,
  //   initialSlide: 0,
  //   freeMode: true,
  //   pagination: {
  //     el: '.swiper-pagination',
  //     type: 'bullets',
  //   },
  // });

  // //SOLUTION DETAIL GALLERY
  // const solGallery = $('.solution-gallery').clone();
  // $('.pattern-technology-hero .sticky-group h1').after(solGallery);
};
